import { Component, Injectable, OnInit, Output, EventEmitter, Input, TemplateRef } from '@angular/core';
import { CampaignService } from '../../../../common/services/Campaign.service';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { SearchService } from '../../../../common/services/Search.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { FieldService } from '../../../../common/services/Field.service';
import { CommonService } from '../../../../common/services/Common.service';
import { EmailService } from '../../../../common/services/Email.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { OrganizeService } from '../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { Observable } from 'rxjs/Rx';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from '../../../../common/services/Socket.service';
import { IvrgatewayService } from 'app/common/services/Ivrgateway.service';
import { QueueService } from 'app/common/services/Queue.service';
import { TimeService } from 'app/common/services/Time.service';
import { environment } from 'environments/environment';
import { ExportService } from 'app/common/services/Export.service';
import { UserService } from 'app/common/services/User.service';
import { GroupService } from 'app/common/services/Group.service';
import { TicketService } from 'app/common/services/Ticket.service';

@Component({
    moduleId: module.id,
    selector: "campaign-detail",
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.css'],
    providers: [CampaignService, BsModalService, SearchService, UploadService, TimeService, GroupService, TicketService,
        FieldService, CommonService, OrganizeService, EvsAddressService, EmailService, IvrgatewayService, QueueService, UserService]
})

@Injectable()
export class DetailComponent implements OnInit {
    @Output('backMode') backMode = new EventEmitter();
    @Input() campaign_id;

    public listFilter: any = [{ id: '', text: '' }];
    public modalRef: any;
    public modalRef2: any;
    public modelFilter: any = {};
    public modelCallOut: any = {}
    public message: { class: string, content: string } = null;
    public message_import: { class: string, content: string } = null;
    public message_modal: { class: string, content: string } = null;
    public campaign: any = {};
    public changeBudget: boolean = false;
    public changeBudgetOnDay: boolean = false;
    public campaignTypes = [
        // { id: 'sms', text: 'Nhắn tin SMS', templateType: 4 },
        { id: 'call', text: 'Gọi điện' },
        // { id: 'facebook', text: 'Chat Facebook', templateType: 2 },
        { id: 'email', text: 'Gửi email', templateType: 1 },
        // { id: 'zalo', text: 'Chat Zalo', templateType: 3 },
    ];
    public dialModes = [
        // { id: 'preview', text: 'Preview' },
        { id: 'progressive', text: 'Progressive' },
        { id: 'Predictive', text: 'Predictive' },
        { id: 'manual', text: 'Manual' },
        { id: 'broadcast', text: 'Broadcast' },
        { id: 'autodial-ivr', text: 'Autodial-IVR' }
        // { id: 'autodial-drop', text: 'Autodial-Drop' }
    ]

    public current_budget: any;
    public current_budget_on_day: any;
    public show: any = 'list';
    public step: number = 1;
    public type_import: any = 'filter_list';
    public model: any = { step1: { type: 'filter' } };
    public headers: any = [{ id: '', text: '' }];
    public fields: any[];
    public mapping: any = {};
    public file_import: any;
    public current_job: any = {};
    public keys: any = [{ id: '', text: '' }];
    public exec_import: any = 'create';
    public key: any;

    public list: any = [];
    public page_size: number = 10;
    public currentPage: number = 1;
    totalItem: any = 0;
    totalPage: any = 0;
    public organizes: any = {};
    public cities: any = {}
    public selected: any = {};
    public is_check_all: boolean = false;
    public have_check: boolean = false;
    public select2_city: any = [{ id: '', text: '' }];
    public select2_organize: any = [{ id: '', text: '' }];
    public complete_load: number = 50;
    public agent_list: any;

    public allTemplate: any = [];
    public emailTemplate: any = [];
    public allEmailAccount: any = [];
    public allGateway: any = [];
    public allQueue: any = [];
    public allSchedule: any = [];
    public file_out: any;
    public listToExport: any = [];
    public exportData: any = [];
    public checkCount: number = 0;
    public allAgent: Array<any> = [];
    public allGroup: any = [];
    public cancel_import: boolean = false;

    constructor(
        private router: Router,
        private campaignService: CampaignService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private searchService: SearchService,
        private uploadService: UploadService,
        private fieldService: FieldService,
        private commonService: CommonService,
        private organizeService: OrganizeService,
        private addressService: EvsAddressService,
        private socketService: SocketService,
        private emailService: EmailService,
        private ivrgatewayService: IvrgatewayService,
        private queueService: QueueService,
        private timeService: TimeService,
        private exportService: ExportService,
        private userService: UserService,
        private groupService: GroupService,
        private ticketService: TicketService
    ) {
    }

    ngOnInit() {
        this.show = 'list';
        // this.detailCampaign();
        this.loadFilter();
        this.keys = [{ id: '', text: '' },
        { id: 'phone', text: 'Điện thoại' },
        { id: 'email', text: 'Email' }];

        this.fields = [{ key: 'name', title: 'Tên' },
        { key: 'phone', title: 'Điện thoại' },
        { key: 'email', title: 'Email' },
        { key: 'address', title: 'Địa chỉ', type: 'text' },
        { key: 'facebook', title: 'Facebook' },
        { key: 'gender', title: 'Giới tính' },
        { key: 'note', title: 'Ghi chú' }];

        // this.modelFilter = {
        //     from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
        //     to: moment().format('YYYY-MM-DD HH:mm')
        // }

        this.loadField();
        this.loadJob();
        this.loadEmailAccount();
        this.loadIvrGateway();
        this.loadQueue();
        this.loadSchedule();
        this.loadEmailTemplate();
        this.getAllAgent();
        this.getGroups();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.detailCampaign();
            // this.loadFilter();
        }, 500);
    }

    loadJob() {
        let where = {
            job_status: {
                "$in": ['pending', 'running']
            }
        }
        this.commonService.findImport({ where: JSON.stringify(where) }).subscribe(res => {
            if (!res.error && res.status == 200) {
                this.current_job = res.data;
                if (this.current_job) {
                    this.step = 3;
                    this.check();
                }
            }
        })
    }

    getAllAgent() {
        this.campaignService.allAgentInQueue(this.campaign_id).toPromise().then(res => {
            let agentList = [];
            res.data.data.forEach((c: any) => {
                agentList.push({
                    text: c.name,
                    id: c._id,
                    group_id: c.group_id
                });
            });
            this.allAgent = agentList;
        });
    }

    // getAllAgent() {
    //     this.userService.all({}).toPromise().then(res => {
    //         let agentList = [];
    //         res.data.forEach((c: any) => {
    //             agentList.push({
    //                 text: c.name,
    //                 id: c._id,
    //                 group_id: c.group_id
    //             });
    //         });
    //         this.allAgent = agentList;
    //     });
    // }

    getGroups() {
        this.groupService.allGroup().subscribe(res => {
            let groupList = [];
            res.data.forEach((c: any) => {
                groupList.push({
                    text: c.name,
                    id: c.id.toString(),
                });
            });
            this.allGroup = groupList;
        });
    }

    loadField() {
        this.fieldService.allField({ target: 'user' }).subscribe(res => {
            if (!res.error && res.status == 200) {
                res.data.forEach(e => {
                    this.fields.push({
                        key: e.key,
                        title: e.title
                    })
                });
            }
        })
    }

    loadEmailAccount(request: any = {}, sort: any = {}) {
        let emailList = [{
            id: "",
            text: "",
        }];
        this.emailService.listAccount(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.forEach(e => {
                    emailList.push({
                        id: e.ID,
                        text: e.ACCOUNT_NAME
                    });
                });

                this.allEmailAccount = emailList;
            }
        });
    }

    loadSchedule(request: any = {}, sort: any = {}) {
        let scheduleList = [{
            id: "",
            text: "",
        }];
        request['limit'] = 500;
        request['keyword'] = "";
        this.timeService.listSchedule(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.data.forEach(e => {
                    scheduleList.push({
                        id: e.TIME_SCHEDULE_ID,
                        text: e.TIME_SCHEDULE_NAME
                    });
                });

                this.allSchedule = scheduleList;
            }
        });
    }

    loadIvrGateway(request: any = {}, sort: any = {}) {
        let allGateway = [{
            id: "",
            text: "",
        }];
        this.ivrgatewayService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.ivrgateways.forEach(e => {
                    allGateway.push({
                        id: e.ivrgateway_id,
                        text: e.line
                    });
                });
                this.allGateway = allGateway;

            }
        });
    }

    loadQueue(request: any = {}, sort: any = {}) {
        let allQueue = [{
            id: "",
            text: "",
        }];
        this.queueService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.queues.forEach(e => {
                    allQueue.push({
                        id: e.QUEUE_ID,
                        text: e.DESCRIPTION
                    });
                });
                this.allQueue = allQueue;

            }
        });
    }

    loadEmailTemplate() {
        let templateList = [];
        let emailList = []
        this.emailService.listTemplate({}).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.forEach(e => {
                    templateList.push({
                        id: e.id.toString(),
                        text: e.template_name,
                        type: e.type
                    });
                    if (e.type == 1) {
                        emailList.push({
                            id: e.id.toString(),
                            text: e.template_name,
                            type: e.type
                        })
                    }
                });

                this.allTemplate = templateList;
                this.emailTemplate = emailList;
            }

        });
    }

    openModalCallOut(template: TemplateRef<any>) {
        this.message_modal = null;
        this.agent_list = 'all';
        this.modelCallOut = {
            agent_ids: [],
            group_ids: [],
            max_customer: 1
        };
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
    }

    public changeUser(e: any): void {
        this.modelCallOut['agent_ids'] = e.value;
    }

    public changeGroup(e: any): void {
        this.modelCallOut['group_ids'] = e.value;
    }

    submitCallOut() {
        this.message_modal = null;
        let agentList = []
        if (this.agent_list == "all") {
            this.allAgent.forEach(agent => {
                agentList.push(agent.id);
            });
        } else if (this.agent_list == "agent") {
            agentList = this.modelCallOut.agent_ids;
        } else if (this.agent_list == "group") {
            this.allAgent.forEach(agent => {
                if (this.modelCallOut.group_ids.indexOf(agent.group_id) > -1) {
                    agentList.push(agent.id);
                }

            });
        }
        console.log(agentList);
        let data = {
            listUserIds: agentList,
            campaignId: this.campaign_id,
            maxCalls: this.modelCallOut.max_customer
        }
        if (this.modelCallOut.max_customer <= 0 || ("" + this.modelCallOut.max_customer).includes(".") || ("" + this.modelCallOut.max_customer).includes("-") || !/^[0-9]*$/.test(this.modelCallOut.max_customer)) {
            this.message_modal = { class: "alert dark alert-danger", content: "Số khách hàng tối đa phải là số nguyên dương" };
        }
        if (!this.message_modal) {
            this.campaignService.assignAgentCampaign(data).subscribe(res => {
                if (!res.error) {
                    this.modalRef.hide()
                    this.toastr.success("Phân bổ thành công", '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.error("Có lỗi, vui lòng thử lại sau", '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            })
        }
    }

    detailCampaign() {
        this.campaignService.find(this.campaign_id).subscribe(res => {
            if (!res.error && res.status == 200) {
                this.campaign = res.data;
                this.current_budget = res.data.budget;
                this.current_budget_on_day = res.data.budget_on_day;
                this.loadContact();
                this.organizeService.allOrganize().subscribe(res => {
                    if (!res.error && res.status == 200) {
                        let orgList = [{ id: '', text: '' }];
                        res.data.forEach(e => {
                            this.organizes[e.id] = e;
                            orgList.push({
                                id: e.organize_id,
                                text: e.name
                            })
                        });
                        this.select2_organize = orgList;
                    }
                })

                // let templateList = [];
                // this.emailService.listTemplate({}).toPromise().then(res => {
                //     if (res.status == 200 && res.error == false) {
                //         res.data.forEach(e => {
                //             templateList.push({
                //                 id: e.id.toString(),
                //                 text: e.template_name,
                //                 type: e.type
                //             });
                //         });

                //         this.allTemplate = templateList;
                //     }

                //     if (this.campaign.campaign_type == "call") {
                //         // this.campaign.template_id = undefined;
                //         // this.campaign.email_account_id = undefined;
                //         this.campaign.dial_mode = this.campaign.dial_mode ? this.campaign.dial_mode : 'progressive';
                //     } else {
                //         // this.campaign.dial_mode = undefined;
                //         // this.campaign.ivrgateway_id = undefined;
                //         // this.campaign.queue_id = undefined;
                //         // this.campaign.callback_url = undefined;
                //         this.emailTemplate = [];
                //         let type = _.find(this.campaignTypes, {id: this.campaign.campaign_type});
                //         if (type) {
                //             this.allTemplate.forEach(e => {
                //                 if (e.type == type.templateType) {
                //                     this.emailTemplate.push(e);
                //                 }
                //             })
                //         }
                //     }
                //     // console.log(this.campaign);
                //     // console.log(this.emailTemplate);
                // });
                this.addressService.getCities().subscribe(res => {
                    let cityList = [{ id: '', text: '' }];
                    res.data.cities.forEach(e => {
                        this.cities[e.id] = e;
                        cityList.push({
                            id: e.id,
                            text: e.name
                        })
                    });
                    this.select2_city = cityList;
                })
            }
        })
    }

    openUser(user) {
        this.socketService.opentab(user, 'user', 'edit');
    }

    openTicket(ticket_id: any) {
        this.ticketService.find(ticket_id).subscribe(rs => {
            if (rs.status == 200 && rs.error == false) {
                let _ticket = rs.data;
                _ticket._id = ticket_id;
                this.userService.find({ _id: _ticket.requester_id }).toPromise().then(res => {
                    if (res.status == 200 && res.error == false) {
                        _ticket.request = res.data;
                        this.socketService.opentab(_ticket, 'ticket', 'edit');
                    }
                })
            }
        })
    }

    loadContact(request: any = {}, sort: any = {}) {
        this.list = [];
        this.listToExport = [];
        // this.selected = {};
        // this.have_check = false;
        // this.is_check_all = false;
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.campaignService.listContact(this.campaign_id, request).toPromise().then(res => {
            if (res.status == 200 && !res.error) {
                this.list = res.data.list;
                this.listToExport = res.data.listToExport;
                this.is_check_all = true;
                this.list.forEach(e => {
                    if (!this.selected[e._id]) {
                        this.is_check_all = false;
                    }
                })
                this.totalItem = res.data.total;
                // this.list.forEach(e => {
                //     e.created_at = moment(e.created_at).utc(false).format("YYYY-MM-DD HH:mm");
                // })
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
            } else {
                this.list = [];
            }

        }, err => {
            this.list = [];
        });
    }

    submitFilter() {
        this.currentPage = 1;
        this.totalItem = this.totalPage = 0;
        let payload = _.assign({}, this.modelFilter);
        payload['is_search'] = true;
        this.loadContact(payload);
    }

    checkAll() {
        this.is_check_all = !this.is_check_all;
        this.list.forEach(e => {
            this.selected[e._id] = this.is_check_all;
            if (this.selected[e._id]) this.checkCount += 1; else this.checkCount -= 1;
        });
        // this.have_check = this.is_check_all;
    }

    selectOne(contact_id) {
        // var total = this.list.length;
        // var count = 0;
        this.selected[contact_id] = !this.selected[contact_id];
        if (this.selected[contact_id]) this.checkCount += 1; else this.checkCount -= 1;
        // Object.keys(this.selected).forEach(key => {
        //     if(this.selected[key]) {
        //         count++;
        //         this.have_check = true;
        //     }
        // });
        // if(total == count){
        //     this.is_check_all = true;
        // } else {
        //     this.is_check_all = false;
        // }
        // if(count == 0){
        //     this.have_check = false;
        // }
        this.is_check_all = true;
        this.list.forEach(e => {
            if (!this.selected[e._id]) {
                this.is_check_all = false;
            }
        })
    }

    saveCampaign() {
        this.campaign.time_start = this.campaign.time_start ? this.campaign.time_start : $('#time_start').val();
        this.campaign.time_end = this.campaign.time_end ? this.campaign.time_end : $('#time_end').val();
        if (this.campaign.time_start.toString().includes("Indochina Time")) {
            this.campaign.time_start = moment(this.campaign.time_start).utc(true).toISOString();
        } else {
            this.campaign.time_start = moment(this.campaign.time_start).utc(false).toISOString();
        }
        if (this.campaign.time_end.toString().includes("Indochina Time")) {
            this.campaign.time_end = moment(this.campaign.time_end).utc(true).toISOString();
        } else {
            this.campaign.time_end = moment(this.campaign.time_end).utc(false).toISOString();
        }
        let message = null;
        if (!this.campaign.name || this.campaign.name.trim() == '') {
            message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        }
        // else if (!this.campaign.budget || this.campaign.budget == 0) {
        //     message = { class: "alert dark alert-danger", content: "Ngân sách không được bỏ trống !" };
        // } 
        else if (!this.campaign.campaign_type) {
            message = { class: "alert dark alert-danger", content: "Kênh không được bỏ trống !" };
        }
        // else if(this.campaign.campaign_type == 'call' && !this.campaign.ivrgateway_id) {
        //     message = { class: "alert dark alert-danger", content: "Đầu số gọi ra không được bỏ trống !" };
        // }
        else if (this.campaign.campaign_type == 'call' && !this.campaign.queue_id) {
            message = { class: "alert dark alert-danger", content: "Queue không được bỏ trống !" };
        }
        else if (this.campaign.campaign_type == 'call' && !this.campaign.dial_mode) {
            message = { class: "alert dark alert-danger", content: "Hình thức không được bỏ trống !" };
        } else if (this.campaign.campaign_type == 'email' && !this.campaign.email_account_id) {
            message = { class: "alert dark alert-danger", content: "Tài khoản email không được bỏ trống !" };
        } else if (this.campaign.campaign_type == 'email' && !this.campaign.template_id) {
            message = { class: "alert dark alert-danger", content: "Mẫu tin nhắn không được bỏ trống !" };
        } else if (!this.campaign.schedule_id) {
            message = { class: "alert dark alert-danger", content: "Lịch làm việc không được bỏ trống !" };
        } else if (!this.campaign.time_start) {
            message = { class: "alert dark alert-danger", content: "Thời gian bắt đầu không được bỏ trống !" };
        } else if (!this.campaign.time_end) {
            message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được bỏ trống !" };
        } else if (this.campaign.time_start && this.campaign.time_end && this.campaign.time_end < this.campaign.time_start) {
            message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được sớm hơn thời gian bắt đầu !" };
        }
        if (message) {
            this.toastr.error(message.content, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } else {
            this.campaign.name = this.campaign.name.trim();
            let payload = _.assign({}, this.campaign);
            delete payload._id;
            delete payload.updated_at;
            delete payload.created_at;
            this.campaignService.update(this.campaign_id, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.current_budget = payload.budget;
                        this.current_budget_on_day = payload.budget_on_day;
                        this.changeBudget = false;
                        this.changeBudgetOnDay = false;
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }

    loadFilter() {
        this.searchService.listFilter({ type: 'user' }).subscribe(res => {
            if (res.status == 200 && !res.error) {
                let filters = [{ id: '', text: '' }];
                res.data.forEach(e => {
                    filters.push({
                        id: e._id,
                        text: e.name
                    })
                });
                this.listFilter = filters;
            }
        })
    }

    changeCampaignType($event) {
        this.campaign.campaign_type = $event.value;
        if ($event.value == "call") {
            // this.campaign.template_id = undefined;
            // this.campaign["email_account_id"] = undefined;
            this.campaign.dial_mode = this.campaign.dial_mode ? this.campaign.dial_mode : 'progressive';
        } else {
            // this.campaign.dial_mode = undefined;
            // this.campaign["ivrgateway_id"] = undefined;
            // this.campaign["queue_id"] = undefined;
            // this.campaign["callback_url"] = undefined;
        }
    }

    changeDialMode($event) {
        this.campaign.dial_mode = $event.value;
    }

    changeTemplate($event) {
        this.campaign.template_id = $event.value;
    }

    changeSchedule($event) {
        this.campaign.schedule_id = $event.value;
    }

    changeEmail($event) {
        this.campaign["email_account_id"] = $event.value;
    }

    changeIvrGateway($event) {
        this.campaign["ivrgateway_id"] = $event.value;
    }

    changeQueue($event) {
        this.campaign["queue_id"] = $event.value;
    }

    openImport() {
        this.show = 'import';

    }

    backToList() {
        this.backMode.emit({
            mode: 'list'
        });
    }

    changeChoiceFilter($event) {
        this.model['step1'] = {
            type: 'filter',
            data: $event.value
        }
    }


    changeFilterCity($event) {
        this.modelFilter.city_id = $event.value;
    }

    changeFilterOrganize($event) {
        this.modelFilter.organize_id = $event.value;
    }

    changeFile($event) {
        if ($event.target.value.length != 0) {
            var files = $event.srcElement.files;
            this.uploadService.uploadExcel(files[0]).then((res: any) => {
                if (!res.error) {
                    let tmpHeaders = [{ id: '', text: '' }];
                    res.data.header.forEach((e, index) => {
                        tmpHeaders.push({
                            id: index,
                            text: e
                        })
                    });
                    this.headers = tmpHeaders;
                    this.file_import = res.data.name;
                    this.model['step1'] = {
                        type: 'file',
                        data: res.data
                    }
                    // $event.target.value = null;
                } else {
                    this.toastr.error(res.data.message, 'Lỗi', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            })
        } else {
            this.model['step1'].data = null;
        }



    }

    choiceFieldMap($event, key) {
        this.mapping[key] = $event.value;
    }

    changedKey($event) {
        this.key = $event.value;
    }

    check() {
        setInterval(function () {
            if (this.step == 3 && this.current_job) {
                this.commonService.findImport({ where: JSON.stringify({ _id: this.current_job._id }) }).subscribe(res => {
                    if (!res.error && res.status == 200 && res.data.job_status == 'stop') {
                        this.step = 4;
                        this.file_out = res.data.file_out ? environment.api_evs + res.data.file_out : "";
                    } else if (this.complete_load < 100) {
                        this.complete_load += 5;
                    }
                })
            }
        }.bind(this), 10000);
    }


    saveImport() {
        let payload: any = {};
        if (this.type_import == 'filter_list') {
            payload = {
                campaign_id: this.campaign_id,
                import_type: 'filter',
                data: this.model.step1.data,
                target: 'user' // user || ticket ..
            }
        } else {
            payload = {
                campaign_id: this.campaign_id,
                import_type: 'import',
                data: this.mapping,
                target: 'user',
                skip_first_row: this.model.skip_first_row,
                file: this.file_import,
                exec_import: this.exec_import,
                key: this.key
            }
        }

        this.commonService.import(payload).subscribe(res => {
            if (res.error) {
                this.message = { class: "alert dark alert-danger", content: "Có lỗi xảy ra, xin vui lòng thử lại." };
            } else {
                this.current_job = res.data;
                this.current_job['just_now'] = true;
                this.check();
            }
        })
    }

    rejectJob() {
        this.commonService.updateImport(this.current_job._id, { job_status: 'reject' }).subscribe(res => {
            if (!res.error) {
                this.step = 4;
                this.cancel_import = true;
            }
        })
    }

    next(step_id) {
        if (step_id != this.step) {
            this.message_import = null;
            switch (step_id) {
                case 4: {
                    this.step = step_id;
                    break;
                }
                case 3: {
                    if (this.type_import == 'import_file' && _.isEmpty(this.mapping)) {
                        this.message_import = { class: "alert dark alert-danger", content: "Xin vui lòng liên kết dữ liệu để import" };
                    } else {
                        this.step = step_id;
                        this.saveImport();
                    }
                    break;
                }
                case 2: {
                    if (!this.model.step1 || !this.model.step1.data) {
                        if (this.type_import == 'filter_list')
                            this.message_import = { class: "alert dark alert-danger", content: "Chọn bộ lọc khách hàng" };
                        else
                            this.message_import = { class: "alert dark alert-danger", content: "Xin vui lòng upload File khách hàng" };
                    } else {
                        if (this.type_import == 'filter_list') {
                            this.saveImport();
                            this.step = 3;
                        } else {
                            if (!this.key) {
                                this.message_import = { class: "alert dark alert-danger", content: "Xin vui lòng chọn định danh" };
                            } else this.step = 2;
                        }
                    }
                    this.file_out = null;
                    break;
                }
                case 1: {
                    this.step = step_id;
                    break;
                }
                default: break;
            }
        }

    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if (y) {
            this.submitDelete();
        }
    }

    redirectToSearch() {
        this.router.navigate(['/search'], { queryParams: { 'tab': 'user' } });
    }

    submitDelete() {
        let delete_ids = [];
        Object.keys(this.selected).forEach(function (key) {
            if (this.selected[key]) {
                delete_ids.push(key);
            }
        }.bind(this));
        return this.campaignService.deleteCampaignContact(this.campaign_id, { contact_ids: delete_ids }).subscribe(res => {
            if (!res.error) {
                setTimeout(() => {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    if (this.is_check_all && this.currentPage > 1) {
                        if (this.currentPage < this.totalPage - 1) {
                            this.currentPage += 1;
                        } else if (this.currentPage == this.totalPage) {
                            this.currentPage -= 1;
                        }
                    }
                    this.checkCount = 0;
                    this.loadContact();
                    // this.modalRef2.hide();
                }, 5000);
            } else {
                this.toastr.error('Xóa không thành công', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        });
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadContact();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadContact();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    export() {
        this.exportData = [];
        this.listToExport.forEach(campaign => {
            this.exportData.push({
                'Người dùng': campaign.name,
                'Điện thoại': campaign.phone,
                'Email': campaign.email,
                'Tổ chức': campaign.organize_id && this.organizes[campaign.organize_id] ? this.organizes[campaign.organize_id].name : '',
                'Thành phố': campaign.city_id && this.cities[campaign.city_id] ? this.cities[campaign.city_id].name : '',
                'Thời gian': campaign.created_at ? moment(campaign.created_at).format("YYYY-MM-DD HH:mm") : moment(Date()).format("YYYY-MM-DD HH:mm"),
                'Số lần gọi': campaign.retry_total,
                'Trạng thái': campaign.status,
            });
        })
        this.exportService.exportExcel(this.exportData, 'Báo cáo khách hàng chiến dịch ' + this.campaign.name + '_' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/campaign/detail.component.ts